<template>
  <section>
    <div class="timer">
      <timer-spinner></timer-spinner>
      <div id="time">{{ timeNow }}</div>
      <div id="units">{{ timeUnits }}</div>
    </div>
    <time-dropdown></time-dropdown>
  </section>
</template>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.timer {
  font-size: 20px;
  color: $white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#time {
  color: $white;
  font-size: 40px;
}

</style>

<script>
import TimerSpinner from "@/components/TeamProfits/TimerSpinner";
import TimeDropdown from "@/components/TeamProfits/TimeDropdown";
export default {
  components: {
    TimerSpinner,
    TimeDropdown
  },
  computed: {
    timeNow() {
      return this.$store.getters.getTime;
    },
    timeUnits() {
      return this.$store.getters.getTimeUnits;
    }
  },
};
</script>

